// ======================================================================
// File Name       : FileUpload
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { FormControl, Col, Button } from 'react-bootstrap';
import $ from 'jquery';

class FileUpload extends React.Component {
  constructor(props) {
    super(props);
    this.clearInput = this.clearInput.bind(this);
  }

  clearInput() {
    const inputId = this.props.inputId ? this.props.inputId : 'file-upload';
    document.getElementById(inputId).value = '';
  }
  render() {
    const labelName = this.props.labelName ? this.props.labelName : '選択';
    const inputId = this.props.inputId ? this.props.inputId : 'file-upload';
    return (
      <Col className="fileinput fileinput-new padding-left-15" data-provides="fileinput">
        <label
          htmlFor={inputId}
          className="btn btn-primary float-start button-form btn-96 margin-clear"
          disabled={this.props.disabled}
        >
          {labelName}
        </label>
        <FormControl
          name={this.props.name}
          id={inputId}
          type="file"
          accept={this.props.accept}
          className="hidden"
          onChange={this.props.onChange}
          disabled={this.props.disabled}
          onClick={this.clearInput} // sprint_20230403 #8
        />
      </Col>
    );
  }
}

export default FileUpload;
